/**
 * Service list rows: purchase time vs client created time for onboard-pending rows.
 * Used for default sort, column sort (purchasedAt), and date-range filters.
 */

export function firestoreOrDateToMillis(value) {
  if (value == null) return null;
  if (typeof value === "object" && typeof value.seconds === "number") {
    return value.seconds * 1000 + (value.nanoseconds || 0) / 1e6;
  }
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? null : ms;
}

export function getServiceRowEffectiveTimeMs(row) {
  const purchaseMs = firestoreOrDateToMillis(row?.purchasedAt);
  if (purchaseMs != null) return purchaseMs;
  if (row?.isOnboardPending) {
    return firestoreOrDateToMillis(row?.clientRecordCreatedAt) ?? 0;
  }
  return 0;
}

export function buildOnboardPendingServiceRow(item, mailLink) {
  return {
    isOnboardPending: true,
    clientRecordCreatedAt: item.createdAt,
    serviceNo: null,
    purchasedAt: null,
    countryCode: item.countryCode ?? {
      label: "(+91) India",
      value: "+91",
      key: "IN",
    },
    step: item.step ?? null,
    name: item.name,
    familyName: item.familyName,
    adminId: item.adminId,
    id: item.id,
    email: item.email,
    phoneNumber: item.phoneNumber,
    address: item.address,
    gender: item.gender,
    dob: item.dob,
    anniversary: item.anniversary,
    preference: item.preference,
    occupation: item.occupation,
    age: item.age,
    leadFrom: item.leadFrom,
    referredBy:
      typeof item.referredBy === "object"
        ? item?.referredBy
        : item?.referredBy,
    status: item.status,
    customerId: item.customerId,
    notes: item.notes,
    mailLink,
    isClientTermsAccepted: item.isClientTermsAccepted,
    isConsentProvided: item.isConsentProvided,
  };
}
